// extracted by mini-css-extract-plugin
export default {"worklowparamDescription":"WorkFlowParameterMapping_worklowparamDescription__tWGGj","defaultToTemplateCheckbox":"WorkFlowParameterMapping_defaultToTemplateCheckbox__58agN"};